"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Portal_1 = __importDefault(require("~/components/UI/Portal"));
const events_1 = require("~/consts/events");
const Modal_scss_1 = __importDefault(require("./Modal.scss"));
function Modal({ modals, setModals, }) {
    const showModalHandler = (data) => {
        setModals((prevState) => [...prevState, data.detail]);
    };
    const hideModalHandler = () => {
        setModals((prevState) => prevState.slice(0, -1));
    };
    (0, react_1.useEffect)(() => {
        document.body.addEventListener(events_1.dispatchShowModal, showModalHandler);
        document.body.addEventListener(events_1.dispatchHideModal, hideModalHandler);
        return () => {
            document.body.removeEventListener(events_1.dispatchShowModal, showModalHandler);
            document.body.removeEventListener(events_1.dispatchHideModal, hideModalHandler);
        };
    }, []);
    return modals.length ? (react_1.default.createElement(react_1.default.Fragment, null, modals.map((modal, idx) => {
        return (
        // eslint-disable-next-line react/no-array-index-key
        react_1.default.createElement(Portal_1.default, { key: idx },
            react_1.default.createElement("div", { className: Modal_scss_1.default.overlay, onMouseDown: (e) => {
                    if (e.button === 1) {
                        e.preventDefault();
                    }
                } },
                react_1.default.createElement("div", { className: Modal_scss_1.default.window }, modal))));
    }))) : null;
}
exports.default = Modal;
